<template>
  <el-autocomplete
    v-if="isAutoCompleteMode"
    id="user_data_select"
    :debounce="500"
    style="width: 100%;"
    :class="'select-default'"
    v-model="selectedOption"
    :fetch-suggestions="search"
    :placeholder="placeholder ? placeholder : placeholderAutocomplete"
    :trigger-on-focus="false"
    @select="handleSelect"
    :disabled="disabled"
  ></el-autocomplete>

  <el-select v-else
    id="user_data_select"
    :class="'select-default'"
    filterable
    clearable
    :disabled="disabled"
    @input="handleSelect"
    :placeholder="placeholder ? placeholder : placeholderSelect"
    v-model="selectedOption">
    <el-option v-for="option in options"
               class="select-default"
               :value="option['@id']"
               :label="option.value"
               :key="option['@id']">
    </el-option>
  </el-select>
</template>

<script>
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'BaseSelectInput',

  data () {
    return {
      selectedOption: this.value,
      userDataOptions: [],
      options: [{ value: '', '@id': '' }]
    }
  },

  props: {
    searchCallback: {
      type: Function,
      required: true
    },
    placeholder: String,
    placeholderAutocomplete: {
      type: String,
      default () {
        return this.$t('views.userdata.form.startTyping')
      }
    },
    placeholderSelect: String,
    isAutoCompleteMode: Boolean,
    value: [String, Number],
    queryParam: String,
    displayValues: Array,
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    getProcessedTextCustom: {
      type: Function,
      required: false
    },
    baseEndpoint: {
      type: String,
      required: false
    }
  },

  watch: {
    selectedOption (val) {
      if (!val) this.handleSelect(null)
    },
    value () {
      this.initialValueHandler()
    }
  },

  mounted () {
    this.initialValueHandler()
  },

  methods: {
    handleSelect (item) {
      this.$emit('select', item)
      if (item && item['@id']) item = item['@id']
      if (this.baseEndpoint && item) {
        item = getId(item)
      }
      this.$emit('input', item)
    },
    async search (queryString, cb) {
      if (queryString.length < 3 && this.isAutoCompleteMode) return
      let params = {}
      params[this.queryParam] = queryString
      let items = await this.searchCallback(params)
      this.options = items.map(item => {
        return {
          '@id': item['@id'],
          value: this.getProcessedText(item)
        }
      })
      cb(this.options)
    },
    async initialValueHandler () {
      if (this.value && (this.isAutoCompleteMode || this.disabled)) {
        await this.updateHandler()
      } else if (!this.isAutoCompleteMode && !this.disabled) {
        let items = await this.searchCallback()
        this.options = items.map(entry => {
          return {
            '@id': entry['@id'],
            value: this.getProcessedText(entry)
          }
        })
        this.selectedOption = this.value
      } else if (!this.value && this.isAutoCompleteMode) {
        this.selectedOption = null
      }
      this.$forceUpdate()
    },
    async updateHandler () {
      let path = this.value
      if (this.baseEndpoint) {
        path = this.baseEndpoint + '/' + this.value
      }
      const response = await new ApiService(path).getResults()
      this.selectedOption = this.getProcessedText(response)
      this.handleSelect(response)
    },
    getProcessedText (entry) {
      if (typeof this.getProcessedTextCustom === 'function') {
        return this.getProcessedTextCustom(entry)
      }
      let text = ''
      this.displayValues.forEach((property, index) => {
        if (property.includes('.')) {
          // https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
          let processedProperty = property.split('.').reduce((o, i) => o[i], entry)
          text += processedProperty + (this.displayValues[index + 1] ? ' ' : '')
        } else {
          text += entry[property] + (this.displayValues[index + 1] ? ' ' : '')
        }
      })
      return text
    }
  }
}
</script>

<style scoped>

</style>
